import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import MarketingSection from '../components/MarketingSection';
import BigDataSection from '../components/BigDataSection';
import TrendsSection from '../components/TrendsSection';
import LatestNewsSection from '../components/LatestNewsSection';
import OurCreationsSection from '../components/OurCreationsSection';
import AIChatAssistant from '../components/AIChatAssistant';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <InfoSection />
      <MarketingSection />
      <BigDataSection />
      <LatestNewsSection />
      <OurCreationsSection />
      <TrendsSection />
      <Footer />
      <CookieConsent />
      <AIChatAssistant />
    </div>
  );
};

export default HomePage;
